import { useNavigate } from 'react-router-dom';
import { Globe2, ArrowRight } from 'lucide-react';
import { formatBytes, formatNextRun } from '../../../utils/overview-format';
import { DIFFICULTY_LABEL, GAMEMODE_LABEL, mcVersionOf } from '../../../utils/mc-labels';
import { InfoGridCard, CardLink } from '../InfoGridCard';
import type { Server } from '../../../types';
import type { McOverview } from './types';

/** „Welt & Server": Eckdaten der Minecraft-Übersicht (aus server.properties + Welt-Ordner). */
export const McWorldCard = ({ overview, server, online }: { overview: McOverview; server: Server; online: boolean }) => {
  const navigate = useNavigate();
  const mc = mcVersionOf(server, overview.software);
  const bedrock = overview.kind === 'bedrock';

  return (
    <InfoGridCard
      icon={<Globe2 size={15} className="text-fg-muted" />}
      title="Welt & Server"
      action={<CardLink onClick={() => navigate(`/server/${server.id}/settings`, { state: { section: 'spiel' } })}>Bearbeiten <ArrowRight size={13} /></CardLink>}
      cells={[
        { label: 'Welt', value: overview.world.name },
        { label: 'Version', value: mc ? <span className="font-mono">{mc}</span> : <span className="text-fg-muted">—</span> },
        {
          label: 'Schwierigkeit',
          value: overview.hardcore ? <span className="text-red-400">Hardcore</span> : DIFFICULTY_LABEL[overview.difficulty] || overview.difficulty,
        },
        { label: 'Spielmodus', value: GAMEMODE_LABEL[overview.gamemode] || overview.gamemode },
        {
          label: overview.content?.kind === 'plugins' ? 'Plugins' : 'Mods',
          value: overview.content ? `${overview.content.count} installiert` : <span className="text-fg-muted">{bedrock ? '—' : 'Keine'}</span>,
        },
        {
          label: bedrock ? 'Allowlist' : 'Whitelist',
          value: overview.whitelist
            ? <span className="text-online">An · nur freigeschaltete Spieler</span>
            : <span className="text-warn">Aus · jeder kann joinen</span>,
        },
        {
          label: 'Weltgröße',
          value: overview.world.bytes != null ? formatBytes(overview.world.bytes) : <span className="text-fg-muted">wird berechnet …</span>,
        },
        {
          label: 'Nächstes Backup',
          value: overview.nextBackupAt
            ? <>
                {formatNextRun(overview.nextBackupAt)}
                {!online && <span className="text-fg-muted"> · nur wenn der Server läuft</span>}
              </>
            : <span className="text-fg-muted">nicht geplant</span>,
        },
      ]}
    />
  );
};
